var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "163px",
    height: "163px",
    viewBox: "0 0 163 163",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-29.000000, -29.000000)",
    fill: "#1EE064"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(29.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#1EE064",
    strokeWidth: 6,
    fillOpacity: 0.1698809,
    cx: 81.5,
    cy: 81.5,
    r: 78.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9943717,116.593669 C70.097083,117.496358 68.8728684,118 67.6011967,118 C66.329525,118 65.1053104,117.496358 64.2080217,116.593669 L37.1091997,89.486641 C34.2969334,86.6739792 34.2969334,82.1130724 37.1091997,79.3056845 L40.5023747,75.9111531 C43.3155199,73.0984913 47.8705123,73.0984913 50.6827786,75.9111531 L67.6011967,92.8328297 L113.317221,47.1094963 C116.130366,44.2968346 120.689753,44.2968346 123.497625,47.1094963 L126.8908,50.5040277 C129.703067,53.3166895 129.703067,57.8767172 126.8908,60.6849842 L70.9943717,116.593669 Z",
    id: "Path",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.9a4b9eebab6c38a542aa5640dc5db714.svg";
export { ForwardRef as ReactComponent };